import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_DARK, SV_LIGHT, SV_TRANSITION, svPressable} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    btn: {
        borderRadius: '50%',
        width: '34px',
        height: '34px',
        border: '1px solid',
        boxShadow: 'none',
        flexShrink: 0,
        transition: SV_TRANSITION,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surface,
            borderColor: SV_LIGHT.lineStrong,
            color: SV_LIGHT.text,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surface,
            borderColor: SV_DARK.lineStrong,
            color: SV_DARK.text,
        },
        ...svPressable,
        '&:hover': {
            ...svPressable['&:hover'],
            opacity: 1,
            '.lightTheme &': {
                backgroundColor: SV_LIGHT.surfaceMuted,
            },
            '.darkTheme &': {
                backgroundColor: SV_DARK.surfaceMuted,
            },
        },
    }
}
